module.exports = fox._r("images/sprite-small-preloader-white.png", __webpack_public_path__ + "_/_/_/root/images/sprite-small-preloader-white.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/sprite-small-preloader-white.png
// module id = 15
// module chunks = 4